import { createRouter } from '@tanstack/react-router';
import type { useAuth } from '@/context/AuthContext';
import { routeTree } from './routeTree.gen';

export interface IRouterContext {
  auth: ReturnType<typeof useAuth>;
}

export const router = createRouter({
  routeTree,
  context: {
    // placeholder — valor real injetado via RouterProvider em index.tsx
    auth: undefined!,
  },
  defaultViewTransition: true,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
